export const GIT_VERSION = '1b1b26a (2026-02-21)';